import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { AzureMariaDBTableDataset } from 'app/model/dataset/azure-maria-db.dataset';
import { tabularTypeDatasetAdapts, TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureMariaDBTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class AzureMariaDBTableDatasetAdapter extends TabularTypeDatasetAdapter<AzureMariaDBTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureMariaDBTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(AzureMariaDBTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureMariaDBTableDataset): Promise<AzureMariaDBTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, AzureMariaDBTableDataset.MODEL);
    }
}
